import $ from 'jquery';

export function initReviews() {
	const q = window.location.hash;
	if (! q) {
		return; 
	}
	$("i", $(q).next('.reviewContent')).click();
}

